// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".filter-item[data-v-b31ce63c] {\n  font-family: var(--interfaceFontTypeface, inherit);\n  color: var(--interfaceFontColor, var(--text-gray-500));\n}\n.filter-item[data-v-b31ce63c] {\n  font-weight: var(--interfaceFontWeight, 700);\n}\n.filter-item[data-v-b31ce63c]:hover,\n.filter-item[data-v-b31ce63c]:focus,\n.filter-item--selected[data-v-b31ce63c] {\n  color: var(--text-blue-600);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
